<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div v-if="balance">
      <!--      {{ date }}-->
      <h5 class="m-0"><strong>{{ user.name }}</strong></h5>
      <p v-for="(amount, curr) in balance.currencies">{{ $AllCurrencies[curr]?.currency }}: <strong>{{
          amount.toLocaleString('ru-RU')
        }}</strong>
      </p>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['user', 'date', 'division'],
  data() {
    return {
      loading: false,
      balance: null,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      const {data} = await api.index('/reports/getReport2?date=' + this.date + '&divId=' + this.division?.id + '&u=' + this.user.id);
      if (data.success) {
        const bal = {
          currencies: Object.keys(data.balance.start).reduce((acc, cId) => {
            acc[cId] = data.balance.start[cId]?.orders ?? 0
            return acc;
          }, {})
        };
        (data.reportData?.orders ?? []).forEach((o) => {
          if (!bal.currencies[o.currency_id]) bal.currencies[o.currency_id] = 0;
          bal.currencies[o.currency_id] += o.c_c_price;
        })
        Object.keys(data.reportData.incomes).forEach((direction) => {
          data.reportData.incomes[direction].forEach((i) => {
            if (i.type_id !== 5) return;
            if (!bal.currencies[i.currency_id]) bal.currencies[i.currency_id] = 0;
            if (direction === 'in') {
              bal.currencies[i.currency_id] += i.sum;
            } else {
              bal.currencies[i.currency_id] -= i.sum;
            }
          })
        })
        data.reportData.expenses.forEach((i) => {
          if (!bal.currencies[i.currency_id]) bal.currencies[i.currency_id] = 0;
          bal.currencies[i.currency_id] -= i.sum;
        })
        this.balance = bal;
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
      }
      this.loading = false;
    }
  }
}

</script>
